import { ThemeOptions } from '@mui/material';

// #region colors
const white = '#ffffff';

const _black = '#000000';

const brand = {
	50: '#f2f8ff',
	100: '#deecff',
	200: '#a7c8f7',
	300: '#7daff4',
	400: '#247af2',
	500: '#0c6cf2',
	600: '#105dc9',
	700: '#1a4b8f',
	800: '#173d73',
	900: '#143057',
	950: '#15263d',
};

const success = {
	50: '#f0fdf4',
	100: '#dcfce7',
	200: '#b9f8cf',
	300: '#7bf1a8',
	400: '#05df72',
	500: '#00c950',
	600: '#00a63e',
	700: '#008236',
	800: '#016630',
	900: '#0d542b',
	950: '#032e15',
};

const warning = {
	50: '#fffbeb',
	100: '#fef3c6',
	200: '#fee685',
	300: '#ffd230',
	400: '#ffb900',
	500: '#fe9a00',
	600: '#e17100',
	700: '#bb4d00',
	800: '#973c00',
	900: '#7b3306',
	950: '#461901',
};

const destructive = {
	50: '#fef2f2',
	100: '#ffe2e2',
	200: '#ffc9c9',
	300: '#ffa2a2',
	400: '#ff6467',
	500: '#fb2c36',
	600: '#e7000b',
	700: '#c10007',
	800: '#9f0712',
	900: '#82181a',
	950: '#460809',
};

const info = {
	50: '#eff6ff',
	100: '#dbeafe',
	200: '#bedbff',
	300: '#8ec5ff',
	400: '#51a2ff',
	500: '#2b7fff',
	600: '#155dfc',
	700: '#1447e6',
	800: '#193cb8',
	900: '#1c398e',
	950: '#162456',
};

const gray = {
	50: '#f8fafc',
	100: '#f1f5f9',
	200: '#e2e8f0',
	300: '#cad5e2',
	400: '#90a1b9',
	500: '#62748e',
	600: '#45556c',
	700: '#314158',
	800: '#1d293d',
	900: '#0f172b',
	950: '#020618',
};

const red = {
	50: '#fef2f2',
	100: '#ffe2e2',
	200: '#ffc9c9',
	300: '#ffa2a2',
	400: '#ff6467',
	500: '#fb2c36',
	600: '#e7000b',
	700: '#c10007',
	800: '#9f0712',
	900: '#82181a',
	950: '#460809',
};

const orange = {
	50: '#fff7ed',
	100: '#ffedd4',
	200: '#ffd6a7',
	300: '#ffb86a',
	400: '#ff8904',
	500: '#ff6900',
	600: '#f54900',
	700: '#ca3500',
	800: '#9f2d00',
	900: '#7e2a0c',
	950: '#441306',
};

const amber = {
	50: '#fffbeb',
	100: '#fef3c6',
	200: '#fee685',
	300: '#ffd230',
	400: '#ffb900',
	500: '#fe9a00',
	600: '#e17100',
	700: '#bb4d00',
	800: '#973c00',
	900: '#7b3306',
	950: '#461901',
};

const yellow = {
	50: '#fefce8',
	100: '#fef9c2',
	200: '#fff085',
	300: '#ffdf20',
	400: '#fdc700',
	500: '#f0b100',
	600: '#d08700',
	700: '#a65f00',
	800: '#894b00',
	900: '#733e0a',
	950: '#432004',
};

const lime = {
	50: '#f7fee7',
	100: '#ecfcca',
	200: '#d8f999',
	300: '#bbf451',
	400: '#9ae600',
	500: '#7ccf00',
	600: '#5ea500',
	700: '#497d00',
	800: '#3c6300',
	900: '#35530e',
	950: '#192e03',
};

const green = {
	50: '#f0fdf4',
	100: '#dcfce7',
	200: '#b9f8cf',
	300: '#7bf1a8',
	400: '#05df72',
	500: '#00c950',
	600: '#00a63e',
	700: '#008236',
	800: '#016630',
	900: '#0d542b',
	950: '#032e15',
};

const emerald = {
	50: '#ecfdf5',
	100: '#d0fae5',
	200: '#a4f4cf',
	300: '#5ee9b5',
	400: '#00d492',
	500: '#00bc7d',
	600: '#009966',
	700: '#007a55',
	800: '#006045',
	900: '#004f3b',
	950: '#002c22',
};

const teal = {
	50: '#f0fdfa',
	100: '#cbfbf1',
	200: '#96f7e4',
	300: '#46ecd5',
	400: '#00d5be',
	500: '#00bba7',
	600: '#009689',
	700: '#00786f',
	800: '#005f5a',
	900: '#0b4f4a',
	950: '#022f2e',
};

const cyan = {
	50: '#ecfeff',
	100: '#cefafe',
	200: '#a2f4fd',
	300: '#53eafd',
	400: '#00d3f2',
	500: '#00b8db',
	600: '#0092b8',
	700: '#007595',
	800: '#005f78',
	900: '#104e64',
	950: '#053345',
};

const sky = {
	50: '#f0f9ff',
	100: '#dff2fe',
	200: '#b8e6fe',
	300: '#74d4ff',
	400: '#00bcff',
	500: '#00a6f4',
	600: '#0084d1',
	700: '#0069a8',
	800: '#00598a',
	900: '#024a70',
	950: '#052f4a',
};

const blue = {
	50: '#eff6ff',
	100: '#dbeafe',
	200: '#bedbff',
	300: '#8ec5ff',
	400: '#51a2ff',
	500: '#2b7fff',
	600: '#155dfc',
	700: '#1447e6',
	800: '#193cb8',
	900: '#1c398e',
	950: '#162456',
};

const indigo = {
	50: '#eef2ff',
	100: '#e0e7ff',
	200: '#c6d2ff',
	300: '#a3b3ff',
	400: '#7c86ff',
	500: '#615fff',
	600: '#4f39f6',
	700: '#432dd7',
	800: '#372aac',
	900: '#312c85',
	950: '#1e1a4d',
};

const violet = {
	50: '#f5f3ff',
	100: '#ede9fe',
	200: '#ddd6ff',
	300: '#c4b4ff',
	400: '#a684ff',
	500: '#8e51ff',
	600: '#7f22fe',
	700: '#7008e7',
	800: '#5d0ec0',
	900: '#4d179a',
	950: '#2f0d68',
};

const purple = {
	50: '#faf5ff',
	100: '#f3e8ff',
	200: '#e9d4ff',
	300: '#dab2ff',
	400: '#c27aff',
	500: '#ad46ff',
	600: '#9810fa',
	700: '#8200db',
	800: '#6e11b0',
	900: '#59168b',
	950: '#3c0366',
};

const fuchsia = {
	50: '#fdf4ff',
	100: '#fae8ff',
	200: '#f6cfff',
	300: '#f4a8ff',
	400: '#ed6aff',
	500: '#e12afb',
	600: '#c800de',
	700: '#a800b7',
	800: '#8a0194',
	900: '#721378',
	950: '#4b004f',
};

const pink = {
	50: '#fdf2f8',
	100: '#fce7f3',
	200: '#fccee8',
	300: '#fda5d5',
	400: '#fb64b6',
	500: '#f6339a',
	600: '#e60076',
	700: '#c6005c',
	800: '#a3004c',
	900: '#861043',
	950: '#510424',
};

const rose = {
	50: '#fff1f2',
	100: '#ffe4e6',
	200: '#ffccd3',
	300: '#ffa1ad',
	400: '#ff637e',
	500: '#ff2056',
	600: '#ec003f',
	700: '#c70036',
	800: '#a50036',
	900: '#8b0836',
	950: '#4d0218',
};
// #endregion colors

const darkTheme: ThemeOptions = {
	palette: {
		mode: 'dark',
		textPrimary: {
			main: gray[900],
		},
		textSecondary: {
			main: gray[700],
		},
		textTertiary: {
			main: gray[600],
		},
		textQuaternary: {
			main: gray[500],
		},
		textBrandPrimary: {
			main: brand[700],
		},
		textBrandSecondary: {
			main: brand[600],
		},
		textBrandTertiary: {
			main: brand[500],
		},
		textWhite: {
			main: white,
		},
		textDisabled: {
			main: gray[500],
		},
		textPlaceholder: {
			main: gray[500],
		},
		textError: {
			main: destructive[600],
		},
		textWarning: {
			main: warning[600],
		},
		textSuccess: {
			main: success[600],
		},
		textInfo: {
			main: info[600],
		},
		bgPrimary: {
			main: white,
		},
		bgPrimaryHover: {
			main: gray[50],
		},
		bgPrimarySolid: {
			main: gray[950],
		},
		bgSecondary: {
			main: gray[50],
		},
		bgSecondaryHover: {
			main: gray[100],
		},
		bgSecondarySolid: {
			main: gray[600],
		},
		bgTertiary: {
			main: gray[100],
		},
		bgQuaternary: {
			main: gray[200],
		},
		bgActive: {
			main: gray[50],
		},
		bgDisabled: {
			main: gray[100],
		},
		bgOverlay: {
			main: gray[950],
		},
		bgBrandPrimary: {
			main: brand[50],
		},
		bgBrandPrimaryAlt: {
			main: brand[50],
		},
		bgBrandSecondary: {
			main: brand[100],
		},
		bgBrandSolid: {
			main: brand[500],
		},
		bgBrandSolidHover: {
			main: brand[600],
		},
		bgBrandSection: {
			main: brand[800],
		},
		bgErrorPrimary: {
			main: destructive[50],
		},
		bgErrorSecondary: {
			main: destructive[100],
		},
		bgErrorSolid: {
			main: destructive[600],
		},
		bgErrorSolidHover: {
			main: destructive[700],
		},
		bgWarningPrimary: {
			main: warning[50],
		},
		bgWarningSecondary: {
			main: warning[100],
		},
		bgWarningSolid: {
			main: warning[600],
		},
		bgSuccessPrimary: {
			main: success[50],
		},
		bgSuccessSecondary: {
			main: success[100],
		},
		bgSuccessSolid: {
			main: success[600],
		},
		bgInfoPrimary: {
			main: info[50],
		},
		bgInfoSecondary: {
			main: info[100],
		},
		bgInfoSolid: {
			main: info[600],
		},
		fgPrimary: {
			main: gray[900],
		},
		fgSecondary: {
			main: gray[700],
		},
		fgTertiary: {
			main: gray[600],
		},
		fgQuaternary: {
			main: gray[400],
		},
		fgWhite: {
			main: white,
		},
		fgDisabled: {
			main: gray[400],
		},
		fgBrandPrimary: {
			main: brand[600],
		},
		fgBrandSecondary: {
			main: brand[500],
		},
		fgErrorPrimary: {
			main: destructive[600],
		},
		fgErrorSecondary: {
			main: destructive[500],
		},
		fgWarningPrimary: {
			main: warning[600],
		},
		fgWarningSecondary: {
			main: warning[500],
		},
		fgSuccessPrimary: {
			main: success[600],
		},
		fgSuccessSecondary: {
			main: success[500],
		},
		fgInfoPrimary: {
			main: info[600],
		},
		fgInfoSecondary: {
			main: info[500],
		},
		borderPrimary: {
			main: gray[300],
		},
		borderPrimarySolid: {
			main: gray[900],
		},
		borderSecondary: {
			main: gray[200],
		},
		borderSecondarySolid: {
			main: gray[500],
		},
		borderTertiary: {
			main: gray[100],
		},
		borderDisabled: {
			main: gray[300],
		},
		borderBrandPrimary: {
			main: brand[500],
		},
		borderBrandSecondary: {
			main: brand[600],
		},
		borderError: {
			main: destructive[500],
		},
		borderWarning: {
			main: warning[500],
		},
		borderSuccess: {
			main: success[500],
		},
		borderInfo: {
			main: info[500],
		},
		utilityGray950: {
			main: gray[950],
		},
		utilityGray900: {
			main: gray[900],
		},
		utilityGray800: {
			main: gray[800],
		},
		utilityGray700: {
			main: gray[700],
		},
		utilityGray600: {
			main: gray[600],
		},
		utilityGray500: {
			main: gray[500],
		},
		utilityGray400: {
			main: gray[400],
		},
		utilityGray300: {
			main: gray[300],
		},
		utilityGray200: {
			main: gray[200],
		},
		utilityGray100: {
			main: gray[100],
		},
		utilityGray50: {
			main: gray[50],
		},
		utilityRed950: {
			main: red[950],
		},
		utilityRed900: {
			main: red[900],
		},
		utilityRed800: {
			main: red[800],
		},
		utilityRed700: {
			main: red[700],
		},
		utilityRed600: {
			main: red[600],
		},
		utilityRed500: {
			main: red[500],
		},
		utilityRed400: {
			main: red[400],
		},
		utilityRed300: {
			main: red[300],
		},
		utilityRed200: {
			main: red[200],
		},
		utilityRed100: {
			main: red[100],
		},
		utilityRed50: {
			main: red[50],
		},
		utilityOrange950: {
			main: orange[950],
		},
		utilityOrange900: {
			main: orange[900],
		},
		utilityOrange800: {
			main: orange[800],
		},
		utilityOrange700: {
			main: orange[700],
		},
		utilityOrange600: {
			main: orange[600],
		},
		utilityOrange500: {
			main: orange[500],
		},
		utilityOrange400: {
			main: orange[400],
		},
		utilityOrange300: {
			main: orange[300],
		},
		utilityOrange200: {
			main: orange[200],
		},
		utilityOrange100: {
			main: orange[100],
		},
		utilityOrange50: {
			main: orange[50],
		},
		utilityAmber950: {
			main: amber[950],
		},
		utilityAmber900: {
			main: amber[900],
		},
		utilityAmber800: {
			main: amber[800],
		},
		utilityAmber700: {
			main: amber[700],
		},
		utilityAmber600: {
			main: amber[600],
		},
		utilityAmber500: {
			main: amber[500],
		},
		utilityAmber400: {
			main: amber[400],
		},
		utilityAmber300: {
			main: amber[300],
		},
		utilityAmber200: {
			main: amber[200],
		},
		utilityAmber100: {
			main: amber[100],
		},
		utilityAmber50: {
			main: amber[50],
		},
		utilityYellow950: {
			main: yellow[950],
		},
		utilityYellow900: {
			main: yellow[900],
		},
		utilityYellow800: {
			main: yellow[800],
		},
		utilityYellow700: {
			main: yellow[700],
		},
		utilityYellow600: {
			main: yellow[600],
		},
		utilityYellow500: {
			main: yellow[500],
		},
		utilityYellow400: {
			main: yellow[400],
		},
		utilityYellow300: {
			main: yellow[300],
		},
		utilityYellow200: {
			main: yellow[200],
		},
		utilityYellow100: {
			main: yellow[100],
		},
		utilityYellow50: {
			main: yellow[50],
		},
		utilityLime950: {
			main: lime[950],
		},
		utilityLime900: {
			main: lime[900],
		},
		utilityLime800: {
			main: lime[800],
		},
		utilityLime700: {
			main: lime[700],
		},
		utilityLime600: {
			main: lime[600],
		},
		utilityLime500: {
			main: lime[500],
		},
		utilityLime400: {
			main: lime[400],
		},
		utilityLime300: {
			main: lime[300],
		},
		utilityLime200: {
			main: lime[200],
		},
		utilityLime100: {
			main: lime[100],
		},
		utilityLime50: {
			main: lime[50],
		},
		utilityGreen950: {
			main: green[950],
		},
		utilityGreen900: {
			main: green[900],
		},
		utilityGreen800: {
			main: green[800],
		},
		utilityGreen700: {
			main: green[700],
		},
		utilityGreen600: {
			main: green[600],
		},
		utilityGreen500: {
			main: green[500],
		},
		utilityGreen400: {
			main: green[400],
		},
		utilityGreen300: {
			main: green[300],
		},
		utilityGreen200: {
			main: green[200],
		},
		utilityGreen100: {
			main: green[100],
		},
		utilityGreen50: {
			main: green[50],
		},
		utilityEmerald950: {
			main: emerald[950],
		},
		utilityEmerald900: {
			main: emerald[900],
		},
		utilityEmerald800: {
			main: emerald[800],
		},
		utilityEmerald700: {
			main: emerald[700],
		},
		utilityEmerald600: {
			main: emerald[600],
		},
		utilityEmerald500: {
			main: emerald[500],
		},
		utilityEmerald400: {
			main: emerald[400],
		},
		utilityEmerald300: {
			main: emerald[300],
		},
		utilityEmerald200: {
			main: emerald[200],
		},
		utilityEmerald100: {
			main: emerald[100],
		},
		utilityEmerald50: {
			main: emerald[50],
		},
		utilityTeal950: {
			main: teal[950],
		},
		utilityTeal900: {
			main: teal[900],
		},
		utilityTeal800: {
			main: teal[800],
		},
		utilityTeal700: {
			main: teal[700],
		},
		utilityTeal600: {
			main: teal[600],
		},
		utilityTeal500: {
			main: teal[500],
		},
		utilityTeal400: {
			main: teal[400],
		},
		utilityTeal300: {
			main: teal[300],
		},
		utilityTeal200: {
			main: teal[200],
		},
		utilityTeal100: {
			main: teal[100],
		},
		utilityTeal50: {
			main: teal[50],
		},
		utilityCyan950: {
			main: cyan[950],
		},
		utilityCyan900: {
			main: cyan[900],
		},
		utilityCyan800: {
			main: cyan[800],
		},
		utilityCyan700: {
			main: cyan[700],
		},
		utilityCyan600: {
			main: cyan[600],
		},
		utilityCyan500: {
			main: cyan[500],
		},
		utilityCyan400: {
			main: cyan[400],
		},
		utilityCyan300: {
			main: cyan[300],
		},
		utilityCyan200: {
			main: cyan[200],
		},
		utilityCyan100: {
			main: cyan[100],
		},
		utilityCyan50: {
			main: cyan[50],
		},
		utilitySky950: {
			main: sky[950],
		},
		utilitySky900: {
			main: sky[900],
		},
		utilitySky800: {
			main: sky[800],
		},
		utilitySky700: {
			main: sky[700],
		},
		utilitySky600: {
			main: sky[600],
		},
		utilitySky500: {
			main: sky[500],
		},
		utilitySky400: {
			main: sky[400],
		},
		utilitySky300: {
			main: sky[300],
		},
		utilitySky200: {
			main: sky[200],
		},
		utilitySky100: {
			main: sky[100],
		},
		utilitySky50: {
			main: sky[50],
		},
		utilityBlue950: {
			main: blue[950],
		},
		utilityBlue900: {
			main: blue[900],
		},
		utilityBlue800: {
			main: blue[800],
		},
		utilityBlue700: {
			main: blue[700],
		},
		utilityBlue600: {
			main: blue[600],
		},
		utilityBlue500: {
			main: blue[500],
		},
		utilityBlue400: {
			main: blue[400],
		},
		utilityBlue300: {
			main: blue[300],
		},
		utilityBlue200: {
			main: blue[200],
		},
		utilityBlue100: {
			main: blue[100],
		},
		utilityBlue50: {
			main: blue[50],
		},
		utilityIndigo950: {
			main: indigo[950],
		},
		utilityIndigo900: {
			main: indigo[900],
		},
		utilityIndigo800: {
			main: indigo[800],
		},
		utilityIndigo700: {
			main: indigo[700],
		},
		utilityIndigo600: {
			main: indigo[600],
		},
		utilityIndigo500: {
			main: indigo[500],
		},
		utilityIndigo400: {
			main: indigo[400],
		},
		utilityIndigo300: {
			main: indigo[300],
		},
		utilityIndigo200: {
			main: indigo[200],
		},
		utilityIndigo100: {
			main: indigo[100],
		},
		utilityIndigo50: {
			main: indigo[50],
		},
		utilityViolet950: {
			main: violet[950],
		},
		utilityViolet900: {
			main: violet[900],
		},
		utilityViolet800: {
			main: violet[800],
		},
		utilityViolet700: {
			main: violet[700],
		},
		utilityViolet600: {
			main: violet[600],
		},
		utilityViolet500: {
			main: violet[500],
		},
		utilityViolet400: {
			main: violet[400],
		},
		utilityViolet300: {
			main: violet[300],
		},
		utilityViolet200: {
			main: violet[200],
		},
		utilityViolet100: {
			main: violet[100],
		},
		utilityViolet50: {
			main: violet[50],
		},
		utilityPurple950: {
			main: purple[950],
		},
		utilityPurple900: {
			main: purple[900],
		},
		utilityPurple800: {
			main: purple[800],
		},
		utilityPurple700: {
			main: purple[700],
		},
		utilityPurple600: {
			main: purple[600],
		},
		utilityPurple500: {
			main: purple[500],
		},
		utilityPurple400: {
			main: purple[400],
		},
		utilityPurple300: {
			main: purple[300],
		},
		utilityPurple200: {
			main: purple[200],
		},
		utilityPurple100: {
			main: purple[100],
		},
		utilityPurple50: {
			main: purple[50],
		},
		utilityFuchsia950: {
			main: fuchsia[950],
		},
		utilityFuchsia900: {
			main: fuchsia[900],
		},
		utilityFuchsia800: {
			main: fuchsia[800],
		},
		utilityFuchsia700: {
			main: fuchsia[700],
		},
		utilityFuchsia600: {
			main: fuchsia[600],
		},
		utilityFuchsia500: {
			main: fuchsia[500],
		},
		utilityFuchsia400: {
			main: fuchsia[400],
		},
		utilityFuchsia300: {
			main: fuchsia[300],
		},
		utilityFuchsia200: {
			main: fuchsia[200],
		},
		utilityFuchsia100: {
			main: fuchsia[100],
		},
		utilityFuchsia50: {
			main: fuchsia[50],
		},
		utilityPink950: {
			main: pink[950],
		},
		utilityPink900: {
			main: pink[900],
		},
		utilityPink800: {
			main: pink[800],
		},
		utilityPink700: {
			main: pink[700],
		},
		utilityPink600: {
			main: pink[600],
		},
		utilityPink500: {
			main: pink[500],
		},
		utilityPink400: {
			main: pink[400],
		},
		utilityPink300: {
			main: pink[300],
		},
		utilityPink200: {
			main: pink[200],
		},
		utilityPink100: {
			main: pink[100],
		},
		utilityPink50: {
			main: pink[50],
		},
		utilityRose950: {
			main: rose[950],
		},
		utilityRose900: {
			main: rose[900],
		},
		utilityRose800: {
			main: rose[800],
		},
		utilityRose700: {
			main: rose[700],
		},
		utilityRose600: {
			main: rose[600],
		},
		utilityRose500: {
			main: rose[500],
		},
		utilityRose400: {
			main: rose[400],
		},
		utilityRose300: {
			main: rose[300],
		},
		utilityRose200: {
			main: rose[200],
		},
		utilityRose100: {
			main: rose[100],
		},
		utilityRose50: {
			main: rose[50],
		},
		sidebarTextActive: {
			main: brand[500],
		},
		sidebarIconActive: {
			main: brand[500],
		},
	},
};

export default darkTheme;
